import store from '@/store'
import { User } from './user'

/**
 * Do's the login and set's access_token
 * @method login
 * @param params - { Object }
 * @returns { Object }
*/
const login = async (params = { email: '', password: '', jwt_token: '' }) => {
  const alreadyLoggedIn = store.getters['common/user/isUserAuthenticated']

  const paramsExist = Boolean(params.email && params.password)

  if (alreadyLoggedIn || !paramsExist) {
    return new Promise((resolve) => { resolve({}) })
  } else {
    const data = await User.login(params)
    const invalidLoginData = !data || !data['access_token'] || !data['user']
    if (invalidLoginData) {
      console.error('Login Error', data)
      User.clearTokenCookies()
    } else {
      User.setJWTTokenCookie(data.access_token, data.jwt_token_exp)
      store.dispatch('common/user/setUser', data['user'])
    }
    return data
  }
}

export default login
